import { initPublicHeader } from './header';

function initHighlightsTimeline() {
    const timelineItems = document.querySelectorAll('.timeline-item');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');
    const timelineProgress = document.querySelector('.timeline-progress');
    const scrollWrapper = document.querySelector('.timeline-scroll-wrapper');
    const timelineLine = document.querySelector('.timeline-line');
    const contentElement = document.querySelector('.highlights-content');

    if (!timelineItems.length || !prevBtn || !nextBtn || !timelineProgress || !scrollWrapper || !timelineLine || !contentElement) {
        return;
    }

    let currentIndex = 0;
    function calculateTimelineLineWidth() {
        const firstItem = timelineItems[0];
        const lastItem = timelineItems[timelineItems.length - 1];
        const totalWidth = lastItem.offsetLeft + lastItem.offsetWidth - firstItem.offsetLeft;

        timelineLine.style.width = `${totalWidth}px`;
    }

    function updateContent(item) {
        const year = item.dataset.year || '';
        const monthName = item.dataset.monthName || '';
        const title = item.dataset.title || '';
        const yearElement = document.createElement('div');
        yearElement.className = 'highlight-year fw-semibold mb-2 lh-1';
        yearElement.textContent = year;

        if (monthName) {
            const monthElement = document.createElement('span');
            monthElement.className = 'fs-1 fw-medium text-capitalize';
            monthElement.textContent = `, ${monthName}`;
            yearElement.appendChild(monthElement);
        }

        const titleElement = document.createElement('div');
        titleElement.className = 'fs-2 fw-medium mb-3';
        titleElement.textContent = title;

        contentElement.replaceChildren(yearElement, titleElement);
        contentElement.classList.remove('reveal-up');
        void contentElement.offsetWidth;
        contentElement.classList.add('reveal-up');
    }

    function scrollToCurrentItem(index) {
        const activeItem = timelineItems[index];
        const scrollPosition = activeItem.offsetLeft - (scrollWrapper.offsetWidth / 2) + (activeItem.offsetWidth / 2);

        scrollWrapper.scrollTo({
            left: scrollPosition,
            behavior: 'smooth',
        });
    }

    function updateProgress(index) {
        const firstItem = timelineItems[0];
        const currentItem = timelineItems[index];
        const lastItem = timelineItems[timelineItems.length - 1];
        const totalDistance = lastItem.offsetLeft + lastItem.offsetWidth - firstItem.offsetLeft;
        const currentDistance = currentItem.offsetLeft + currentItem.offsetWidth - firstItem.offsetLeft;

        timelineProgress.style.width = `${(currentDistance / totalDistance) * 100}%`;
    }

    function updateNavigation() {
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === timelineItems.length - 1;
    }

    function activateTimelineItem(index) {
        timelineItems.forEach((item, i) => {
            const yearElement = item.querySelector('.timeline-year');
            const monthElement = item.querySelector('.timeline-month');

            if (i <= index) {
                item.classList.add('past');

                if (i === index) {
                    item.classList.add('active');
                    yearElement?.classList.replace('fw-medium', 'fw-semibold');
                    yearElement?.classList.replace('fs-4', 'fs-3');
                    monthElement?.classList.replace('fw-medium', 'fw-semibold');
                    monthElement?.classList.replace('fs-6', 'fs-5');
                } else {
                    item.classList.remove('active');
                    yearElement?.classList.replace('fw-semibold', 'fw-medium');
                    yearElement?.classList.replace('fs-3', 'fs-4');
                    monthElement?.classList.replace('fw-semibold', 'fw-medium');
                    monthElement?.classList.replace('fs-5', 'fs-6');
                }
            } else {
                item.classList.remove('active', 'past');
                yearElement?.classList.replace('fw-semibold', 'fw-medium');
                yearElement?.classList.replace('fs-3', 'fs-4');
                monthElement?.classList.replace('fw-semibold', 'fw-medium');
                monthElement?.classList.replace('fs-5', 'fs-6');
            }
        });

        updateContent(timelineItems[index]);
        scrollToCurrentItem(index);
        updateProgress(index);
        updateNavigation();
    }

    calculateTimelineLineWidth();
    window.addEventListener('resize', calculateTimelineLineWidth);

    timelineItems.forEach((item, index) => {
        item.addEventListener('click', () => {
            currentIndex = index;
            activateTimelineItem(currentIndex);
        });
    });

    prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
            currentIndex--;
            activateTimelineItem(currentIndex);
        }
    });

    nextBtn.addEventListener('click', () => {
        if (currentIndex < timelineItems.length - 1) {
            currentIndex++;
            activateTimelineItem(currentIndex);
        }
    });

    activateTimelineItem(currentIndex);
}

document.addEventListener('DOMContentLoaded', function () {
    initPublicHeader();
    initHighlightsTimeline();
});